import { BrandId } from '@nsw-paginas-deslogadas/constants'
import { Mapping } from '@nsw-paginas-deslogadas/typings'
import { Images } from './../images'

const BASE_URL = String(process.env.BASE_PUBLIC_URL)

const BrandMapping: { [key: string]: Mapping } = {
    [BrandId.Nav]: {
        name: 'Nav Dasa',
        id: 0,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?redirectTo=/vacinas/paciente&brandId=0&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?redirectTo=/vacinas/paciente&brandId=0&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?redirectTo=/vacinas/paciente&brandId=0&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?redirectTo=/vacinas/paciente&brandId=0&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
            {
                title: 'Como usar meu cupom de desconto?',
                text: 'Você pode agendar seus exames e vacinas comigo, sua plataforma de saúde pra toda a vida! Basta acessar https://nav.dasa.com.br/entrar. No dia de seu atendimento, solicitamos que gentilmente apresente seu cupom de desconto à atendente responsável.',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?redirectTo=/vacinas/paciente&brandId=0&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Gripe Quadrivalente', id: 13385 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandId=0&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Nav Dasa | Agendamento online de exames e vacinas',
            metaDescription:
                'No Nav Dasa, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.AltaSp]: {
        name: 'Alta',
        id: 19,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Pneumococica', id: 13398 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Teste do Pezinho', id: 8896 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: false,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Alta | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Alta, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames e vacinas no Alta direto pelo Nav Dasa.',
                subtitle: 'Conte com uma experiência única e do tamanho da sua expectativa: ALTA.',
                backgroundImage: { src: Images.AltaBackground.src, alt: Images.AltaBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'A combinação perfeita entre a agilidade e precisão para realizar seus exames e vacinas.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Autonomia',
                        text: 'Escolha o dia e o horário pra se cuidar no ritmo da sua saúde.',
                    },
                    {
                        icon: 'Swiping',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#3BD1D6',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#B55635',
                title: 'Sua experiência inclui:',
                backgroundColor: '#F1F2EE',
                buttonBackgroundColor: '#FFF',
                buttonTextColor: '#000E40',
                cardColor: '#3BD1D6',
            },
            foldFaq: {
                titleColor: '#B55635',
                buttonBackgroundColor: '#3BD1D6',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.AltaRj]: {
        name: 'Alta',
        id: 19,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/vacinas/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Hepatite A+B', id: 13388 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=alta&redirectTo=/agd-exames/paciente&brandId=19&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Troponina I', id: 964 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: false,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Alta | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Alta, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames e vacinas no Alta direto pelo Nav Dasa.',
                subtitle: 'Conte com uma experiência única e do tamanho da sua expectativa: ALTA.',
                backgroundImage: { src: Images.AltaBackground.src, alt: Images.AltaBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'A combinação perfeita entre a agilidade e precisão para realizar seus exames e vacinas.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Autonomia',
                        text: 'Escolha o dia e o horário pra se cuidar no ritmo da sua saúde.',
                    },
                    {
                        icon: 'Swiping',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#3BD1D6',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#B55635',
                title: 'Sua experiência inclui:',
                backgroundColor: '#F1F2EE',
                buttonBackgroundColor: '#FFF',
                buttonTextColor: '#000E40',
                cardColor: '#3BD1D6',
            },
            foldFaq: {
                titleColor: '#B55635',
                buttonBackgroundColor: '#3BD1D6',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.Alvaro]: {
        name: 'Alvaro',
        id: 10,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/vacinas/paciente&brandId=10&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/vacinas/paciente&brandId=10&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/vacinas/paciente&brandId=10&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/vacinas/paciente&brandId=10&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/vacinas/paciente&brandId=10&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Pneumococica', id: 13398 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=alvaro&redirectTo=/agd-exames/paciente&brandId=10&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'Avidez IGG E IGM', id: 1613 },
                    { name: 'Teste do Pezinho', id: 8896 },
                    { name: 'Estímulo de Gastrina', id: 7944 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Alvaro | Agendamento online de exames e vacinas',
            metaDescription:
                'No Alvaro, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Atalaia]: {
        name: 'Atalaia',
        id: 14,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/vacinas/paciente&brandId=14&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/vacinas/paciente&brandId=14&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/vacinas/paciente&brandId=14&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/vacinas/paciente&brandId=14&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/vacinas/paciente&brandId=14&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Pneumococica', id: 13398 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=atalaia&redirectTo=/agd-exames/paciente&brandId=14&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Teste do Pezinho', id: 8896 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Atalaia | Agendamento online de exames e vacinas',
            metaDescription:
                'No Atalaia, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Bronstein]: {
        name: 'Bronstein',
        id: 3,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/vacinas/paciente&brandId=3&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/vacinas/paciente&brandId=3&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/vacinas/paciente&brandId=3&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/vacinas/paciente&brandId=3&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/vacinas/paciente&brandId=3&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Pneumococica', id: 13398 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=bronstein&redirectTo=/agd-exames/paciente&brandId=3&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Bronstein | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Bronstein, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Bronstein.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Bronstein e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Garanta mais agilidade e prioridade no atendimento nas nossas unidades fazendo o seu agendamento.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#F28C3C',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Bronstein pelo Nav Dasa:',
                backgroundColor: '#004288',
                buttonBackgroundColor: '#F28C3C',
                buttonTextColor: '#000E40',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.CedicCedilab]: {
        name: 'Cedic Cedilab',
        id: 101,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/vacinas/paciente&brandId=101&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/vacinas/paciente&brandId=101&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/vacinas/paciente&brandId=101&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/vacinas/paciente&brandId=101&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, vacinas e exames de análises.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'USG Transvaginal', id: 11513 },
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'USG de Abdome Total', id: 11364 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/vacinas/paciente&brandId=101&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Combo Meningos', id: 40437 },
                    { name: 'Hexavalente Infantil', id: 40400 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=cedilab&redirectTo=/agd-exames/paciente&brandId=101&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'Teste do Pezinho', id: 8896 },
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Funcional HGH', id: 7765 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Cedic Cedilab | Agendamento online de exames e vacinas',
            metaDescription:
                'No Cedic Cedilab, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Cerpe]: {
        name: 'Cerpe',
        id: 34,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'Creatinina', id: 364 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'DTPA tipo adulto', id: 13381 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/agd-exames/paciente&brandId=34&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste de Disbiose', id: 7864 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Cerpe | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Cerpe, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Cerpe.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Cerpe e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#E71E28',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Cerpe pelo Nav Dasa:',
                backgroundColor: '#E71E28',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.Cytolab]: {
        name: 'Cytolab',
        id: 27,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/vacinas/paciente&brandId=27&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/vacinas/paciente&brandId=27&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/vacinas/paciente&brandId=27&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/vacinas/paciente&brandId=27&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/vacinas/paciente&brandId=27&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Meningococica (MENVEO)', id: 13380 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=cytolab&redirectTo=/agd-exames/paciente&brandId=27&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'COVID-19 Antígeno', id: 14541 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Cytolab | Agendamento online de exames e vacinas',
            metaDescription:
                'No Cytolab, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Delboni]: {
        name: 'Delboni',
        id: 1,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/vacinas/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/vacinas/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/vacinas/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/vacinas/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/vacinas/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=delboni&redirectTo=/agd-exames/paciente&brandId=1&dasa_source=delboni&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Delboni | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Delboni, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames e vacinas no Delboni pelo Nav Dasa.',
                subtitle: 'No tempo que você precisa e com apenas alguns cliques.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de Agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#fff',
            },
            swiper: {
                titleColor: '#fff',
                title: 'Agendamento no Delboni pelo Nav Dasa:',
                backgroundColor: '#CF0F40',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#fff',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#B55635',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#fff',
            },
        },
    },
    [BrandId.Deliberato]: {
        name: 'Deliberato',
        id: 102,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/vacinas/paciente&brandId=102&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/vacinas/paciente&brandId=102&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/vacinas/paciente&brandId=102&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/vacinas/paciente&brandId=102&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Papanicolau', id: 7082 },
                    { name: 'Espermograma', id: 2809 },
                    { name: 'Sexagem Fetal', id: 4612 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=deliberato&redirectTo=/agd-exames/paciente&brandId=102&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'Tolerância a Lactose', id: 667 },
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'COVID-19 Antígeno', id: 14541 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Deliberato | Agendamento online de exames',
            metaDescription:
                'No Deliberato, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Exame]: {
        name: 'Exame',
        id: 15,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/vacinas/paciente&brandId=15&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/vacinas/paciente&brandId=15&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/vacinas/paciente&brandId=15&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/vacinas/paciente&brandId=15&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/vacinas/paciente&brandId=15&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Pneumococica', id: 13398 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=exame&redirectTo=/agd-exames/paciente&brandId=15&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'COVID-19 Antígeno', id: 14541 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Exame | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Exame, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Exame.',
                subtitle: 'Agora é tudo comigo, a sua plataforma de saúde digital. É simples, rápido e descomplicado.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#CF0F40',
                buttonTextColor: '#fff',
            },
            swiper: {
                titleColor: '#000E40',
                title: 'Agendamento no Exame pelo Nav Dasa:',
                backgroundColor: '#A3CA60',
                buttonBackgroundColor: '#CF0F40',
                buttonTextColor: '#fff',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#CF0F40',
                buttonTextColor: '#fff',
            },
        },
    },
    [BrandId.FrischmannAisengart]: {
        name: 'Frischmann Aisengart',
        id: 8,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/vacinas/paciente&brandId=8&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/vacinas/paciente&brandId=8&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/vacinas/paciente&brandId=8&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/vacinas/paciente&brandId=8&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/vacinas/paciente&brandId=8&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Pneumococica', id: 13398 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=frischmann&redirectTo=/agd-exames/paciente&brandId=8&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Frischmann Aisengart | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Frischmann Aisengart, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Frischmann.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Frischmann Aisengart e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#62B5E5',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Frischmann Aisengart pelo Nav Dasa:',
                backgroundColor: '#00629B',
                buttonBackgroundColor: '#62B5E5',
                buttonTextColor: '#000E40',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#62B5E5',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.GilsonCidrim]: {
        name: 'Gilson Cidrim',
        id: 37,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/vacinas/paciente&brandId=37&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/vacinas/paciente&brandId=37&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/vacinas/paciente&brandId=37&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/vacinas/paciente&brandId=37&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'Beta HCG', id: 1503 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=gilsoncidrim&redirectTo=/agd-exames/paciente&brandId=37&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'COVID-19 Antígeno', id: 14541 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Gilson Cidrim | Agendamento online de exames',
            metaDescription:
                'No Gilson Cidrim, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.ImageMemorial]: {
        name: 'Image Memorial',
        id: 12,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/vacinas/paciente&brandId=12&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/vacinas/paciente&brandId=12&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/vacinas/paciente&brandId=12&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/vacinas/paciente&brandId=12&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Abdome Total', id: 11364 },
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/vacinas/paciente&brandId=12&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Hepatite B Adulto', id: 13389 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=imagememorial&redirectTo=/agd-exames/paciente&brandId=12&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Image Memorial | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Image Memorial, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Image Memorial.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Image Memorial e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Image Memorial pelo Nav Dasa:',
                backgroundColor: '#123F69',
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.Itulab]: {
        name: 'Itulab',
        id: 105,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/vacinas/paciente&brandId=105&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/vacinas/paciente&brandId=105&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/vacinas/paciente&brandId=105&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/vacinas/paciente&brandId=105&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem e exames de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Sexagem Fetal', id: 4612 },
                    { name: 'Genera Standard', id: 14289 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=itulab&redirectTo=/agd-exames/paciente&brandId=105&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'Teste do Pezinho', id: 8896 },
                    { name: 'COVID-19 Antígeno', id: 14541 },
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Itulab | Agendamento online de exames',
            metaDescription:
                'No Itulab, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Lamina]: {
        name: 'Lâmina',
        id: 4,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/vacinas/paciente&brandId=4&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/vacinas/paciente&brandId=4&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/vacinas/paciente&brandId=4&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/vacinas/paciente&brandId=4&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/vacinas/paciente&brandId=4&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Pneumococica', id: 13398 },
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Vacinas Meningo', id: 40437 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=lamina&redirectTo=/agd-exames/paciente&brandId=4&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Lâmina | Agendamento online de exames e vacinas',
            metaDescription:
                'No Lâmina, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.LaminaDiagnosticos]: {
        name: 'Lâmina Diagnósticos',
        id: 13,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/agd-exames/paciente&brandId=13&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/vacinas/paciente&brandId=13&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/agd-exames/paciente&brandId=13&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/vacinas/paciente&brandId=13&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/agd-exames/paciente&brandId=13&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/vacinas/paciente&brandId=13&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/agd-exames/paciente&brandId=13&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/vacinas/paciente&brandId=13&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=laminasc&redirectTo=/agd-exames/paciente&brandId=13&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'USG Transvaginal', id: 11513 },
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'USG de Abdome Total', id: 11364 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Lâmina Diagnósticos | Agendamento online de exames',
            metaDescription:
                'No Lâmina Diagnósticos, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Lavoisier]: {
        name: 'Lavoisier',
        id: 2,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/vacinas/paciente&brandId=2&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/vacinas/paciente&brandId=2&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/vacinas/paciente&brandId=2&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/vacinas/paciente&brandId=2&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.BlueBecker.src,
                    alt: Images.BlueBecker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/vacinas/paciente&brandId=2&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.BlueSyringe.src,
                    alt: Images.BlueSyringe.alt,
                },
                exams: [
                    { name: 'Meningococica B', id: 13395 },
                    { name: 'Gripe Quadrivalente', id: 13385 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=lavoisier&redirectTo=/agd-exames/paciente&brandId=2&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.BlueGlass.src,
                    alt: Images.BlueGlass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Lavoisier | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Lavoisier, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames e vacinas no Lavoisier direto pelo Nav Dasa.',
                subtitle: 'Mais praticidade para o seu atendimento.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'OrangeClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'OrangeCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'OrangeMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#F68B1F',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Lavoisier pelo Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#0095DA',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#F68B1F',
                buttonBackgroundColor: '#F68B1F',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.Leme]: {
        name: 'Leme',
        id: 40,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Espermograma', id: 2809 },
                    { name: 'Sexagem Fetal', id: 4612 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Pneumococica 13', id: 13398 },
                    { name: 'Meningococica (MENVEO)', id: 13380 },
                    { name: 'Zoster Recombinante', id: 41266 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/agd-exames/paciente&brandId=40&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                    { name: 'Teste do Pezinho', id: 8896 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Leme | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Leme, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Leme.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Leme e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Leme pelo Nav Dasa:',
                backgroundColor: '#123F69',
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#C7922C',
                buttonTextColor: '#000E40',
            },
        },
    },
    [BrandId.OswaldoCruz]: {
        name: 'Oswaldo Cruz',
        id: 39,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/vacinas/paciente&brandId=39&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/vacinas/paciente&brandId=39&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/vacinas/paciente&brandId=39&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/vacinas/paciente&brandId=39&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Genera Completo', id: 14288 },
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Sexagem Fetal', id: 4612 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=oswaldocruz&redirectTo=/agd-exames/paciente&brandId=39&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Espermograma', id: 2809 },
                    { name: 'Teste do Pezinho', id: 8896 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Oswaldo Cruz | Agendamento online de exames',
            metaDescription:
                'No Oswaldo Cruz, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.Previlab]: {
        name: 'Previlab',
        id: 32,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/vacinas/paciente&brandId=32&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/vacinas/paciente&brandId=32&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/vacinas/paciente&brandId=32&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/vacinas/paciente&brandId=32&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/vacinas/paciente&brandId=32&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonVaccines.src,
                    alt: Images.PersonVaccines.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=previlab&redirectTo=/agd-exames/paciente&brandId=32&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                    { name: 'Avidez IGG E IGM', id: 1613 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'Previlab | Agendamento online de exames e vacinas',
            metaDescription:
                'No Previlab, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.SalomaoZoppi]: {
        name: 'Salomão Zoppi',
        id: 42,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/vacinas/paciente&brandId=42&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/vacinas/paciente&brandId=42&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/vacinas/paciente&brandId=42&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/vacinas/paciente&brandId=42&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'USG de Mamas', id: 11438 },
                    { name: 'Mamografia Digital', id: 10193 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/vacinas/paciente&brandId=42&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=salomaoezoppi&redirectTo=/agd-exames/paciente&brandId=42&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Teste Ergométrico', id: 11275 },
                    { name: 'Troponina I', id: 964 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Salomão Zoppi | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Salomão Zoppi, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Salomão Zoppi.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Salomão Zoppi e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Garanta mais agilidade e prioridade no atendimento nas nossas unidades fazendo o seu agendamento.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#2BD6C4',
                buttonTextColor: '#000E40',
            },
            swiper: {
                titleColor: '#000E40',
                title: 'Agendamento no Salomão Zoppi pelo Nav Dasa:',
                backgroundColor: '#9C86E0',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.SergioFranco]: {
        name: 'Sérgio Franco',
        id: 24,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/agd-exames/paciente&brandId=24&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Sérgio Franco | Agendamento online de exames e vacinas',
                    metaDescription:
                        'No Sérgio Franco, o agendamento de exames, vacinas e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agendamento online de exames e vacinas no Sérgio Franco.',
                subtitle: 'Agende seus exames e vacinas comigo, plataforma de saúde digital do Sérgio Franco e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#009C72',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Sérgio Franco pelo Nav Dasa:',
                backgroundColor: '#00695A',
                buttonBackgroundColor: '#302D83',
                buttonTextColor: '#FFFFFF',
                cardColor: '#FFFFFF',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#302D83',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.ValeClin]: {
        name: 'ValeClin',
        id: 59,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/vacinas/paciente&brandId=59&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/vacinas/paciente&brandId=59&origin=pagina_deslogada_marca`,
            },
            faq: {
                exams: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/vacinas/paciente&brandId=59&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/vacinas/paciente&brandId=59&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonAnalysingWithMask.src,
                    alt: Images.PersonAnalysingWithMask.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'TSH', id: 5864 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=valeclin&redirectTo=/agd-exames/paciente&brandId=59&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.PersonTests.src,
                    alt: Images.PersonTests.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Tolerância a Lactose', id: 667 },
                    { name: 'Teste do Pezinho', id: 8896 },
                ],
            },
        ],
        renderLPV2: false,
        renderPromoBanner: true,
        lpV1Seo: {
            title: 'ValeClin | Agendamento online de exames',
            metaDescription:
                'No ValeClin, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
        },
    },
    [BrandId.SaoCamilo]: {
        name: 'São Camilo',
        id: 127,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: false,
                exams: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem e de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=camilordi&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'São Camilo | Agendamento online de exames',
                    metaDescription:
                        'No São Camilo, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames de imagem no São Camilo pelo Nav Dasa',
                subtitle: 'Agende seus exames no Nav Dasa, a plataforma de saúde digital do São Camilo e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'RedClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'RedCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'RedMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#E81B23',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no São Camilo pelo Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#E81B23',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#E81B23',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.MultiImagemRJ]: {
        name: 'Multi-Imagem',
        id: 29,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=29&dasa_source=multiimagem_rio&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_rio&redirectTo=/vacinas/paciente&brandId=29&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=29&dasa_source=multiimagem_rio&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_rio&redirectTo=/vacinas/paciente&brandId=29&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: false,
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=29&dasa_source=multiimagem_rio&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_rio&redirectTo=/vacinas/paciente&brandId=29&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=29&dasa_source=multiimagem_rio&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_rio&redirectTo=/vacinas/paciente&brandId=29&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem e de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=29&dasa_source=multiimagem_rio&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio==multiimagem_rio&redirectTo=/vacinas/paciente&brandId=127&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio==multiimagem_rio&redirectTo=/agd-exames/paciente&brandId=127&dasa_source=saocamilo_rdi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Multi-Imagem RJ | Agendamento online de exames',
                    metaDescription:
                        'No Multi-Imagem RJ, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames na Multi-Imagem pelo Nav Dasa',
                subtitle:
                    'Agende seus exames de ressonância magnética no Nav Dasa, a plataforma de saúde digital do Multi-Imagem Rio de Janeiro - RJ e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'DarkBlueClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'DarkBlueCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'DarkBlueMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Multi-Imagem Rio de Janeiro - RJ Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.MultiImagemPetropolis]: {
        name: 'Multi-Imagem',
        id: 28,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_petropolis&redirectTo=/vacinas/paciente&brandId=28&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_petropolis&redirectTo=/vacinas/paciente&brandId=28&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: false,
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_petropolis&redirectTo=/vacinas/paciente&brandId=28&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=multiimagem_petropolis&redirectTo=/vacinas/paciente&brandId=28&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem e de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=multiimagem&redirectTo=/agd-exames/paciente&brandId=28&dasa_source=multiimagem_petropolis&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Multi-Imagem Petrópolis | Agendamento online de exames',
                    metaDescription:
                        'No Multi-Imagem Petrópolis, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames na Multi-Imagem pelo Nav Dasa',
                subtitle:
                    'Agende seus exames de ressonância magnética no Nav Dasa, a plataforma de saúde digital do Multi-Imagem Petrópolis - RJ e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'DarkBlueClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'DarkBlueCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'DarkBlueMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Multi-Imagem Rio de Janeiro - RJ Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#00246A',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.CDPIRIO]: {
        name: 'CDPI',
        id: 25,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi_rio&redirectTo=/vacinas/paciente&brandId=25&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi_rio&redirectTo=/vacinas/paciente&brandId=25&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: false,
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi_rio&redirectTo=/vacinas/paciente&brandId=25&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca `,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi_rio&redirectTo=/vacinas/paciente&brandId=25&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de exames realizados?',
                text: 'Realizamos exames de imagem.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os serviços que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio==cdpi_rio&redirectTo=/vacinas/paciente&brandId=25&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio==cdpi_rio&redirectTo=/agd-exames/paciente&brandIds=17,25&dasa_source=cdpi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'CDPI RJ | Agendamento online de exames',
                    metaDescription:
                        'No CDPI RJ, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames na CDPI Rio de Janeiro pelo Nav Dasa',
                subtitle:
                    'Agende seus exames de imagem no Nav Dasa, a plataforma de saúde digital do CDPI Rio de Janeiro - RJ e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'BlueClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'BlueCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'BlueMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Multi-Imagem Rio de Janeiro - RJ Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.CDPI]: {
        name: 'CDPI',
        id: 17,
        vaccine: false,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/vacinas/paciente&brandId=17&origin=pagina_deslogada_marca`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/vacinas/paciente&brandId=17&origin=pagina_deslogada_marca`,
            },
            faq: {
                vaccineActive: false,
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/vacinas/paciente&brandId=17&origin=pagina_deslogada_marca`,
            },
            about: {
                exams: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                vaccines: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/vacinas/paciente&brandId=17&origin=pagina_deslogada_marca`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem e de análises clínicas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?laboratorio=cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio==cdpi&redirectTo=/vacinas/paciente&brandId=17&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio==cdpi&redirectTo=/agd-exames/paciente&brandId=17&dasa_source=cdpi_niteroi&origin=pagina_deslogada_marca`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'CDPI Niterói | Agendamento online de exames',
                    metaDescription:
                        'No CDPI Niterói, o agendamento de exames e consultas médicas é feito no Nav Dasa. Agende online e acesse todo o seu histórico de exames em um só lugar.',
                },
                title: 'Agende seus exames na CDPI Niterói pelo Nav Dasa',
                subtitle: 'Agende seus exames de imagem no Nav Dasa, a plataforma de saúde digital do CDPI Niterói - RJ e sua também.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'BlueClock',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'BlueCalendar',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'BlueMagnifier',
                        title: 'Acompanhamento',
                        text: 'Acesse seus agendamentos, remarque ou cancele de onde estiver, quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agendamento no Multi-Imagem Rio de Janeiro - RJ Nav Dasa:',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.CerpeBoris]: {
        name: 'CerpeBoris',
        id: 342016,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=34,2016&dasa_source=cerpeboris&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=34,2016&dasa_source=cerpeboris&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=34,2016&dasa_source=cerpeboris&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            about: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=34,2016&dasa_source=cerpeboris&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=34,2016&dasa_source=cerpeboris&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=cerpe&redirectTo=/vacinas/paciente&brandId=34&dasa_source=cerpe&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Cerpe e Bóris Berenstein | Agendamento online de exames e vacinas',
                    metaDescription:
                        'Agende seus exames e vacinas no Nav Dasa, a plataforma digital de saúde dos Laboratórios Cerpe e Bóris Berenstein.',
                },
                title: 'Agende seus exames e vacinas nos Laboratórios Cerpe e Bóris Berenstein.',
                subtitle: 'Faça seu agendamento com o Nav Dasa, nossa plataforma de saúde digital.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agende seus exames e vacinas nos Laboratórios Cerpe e Bóris Berenstein.',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#000E40',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.ImageLeme]: {
        name: 'ImageLeme',
        id: 4012,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=40,12&dasa_source=lemeimage&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=40,12&dasa_source=lemeimage&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=40,12&dasa_source=lemeimage&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            about: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=40,12&dasa_source=lemeimage&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=40,12&dasa_source=lemeimage&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=leme&redirectTo=/vacinas/paciente&brandId=40&dasa_source=leme&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Image e Leme | Agendamento online de exames e vacinas',
                    metaDescription:
                        'Agende seus exames e vacinas no Nav Dasa, a plataforma digital de saúde dos Laboratórios Image e Leme.',
                },
                title: 'Agende seus exames e vacinas nos Laboratórios Image e Leme.',
                subtitle: 'Faça seu agendamento com o Nav Dasa, nossa plataforma de saúde digital.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#184066',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agende seus exames e vacinas nos Laboratórios Image e Leme.',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#184066',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
    [BrandId.SergioFrancoCDPI]: {
        name: 'SergioFrancoCDPI',
        id: 242517,
        vaccine: true,
        exam: true,
        buttons: {
            header: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=24,25,17&dasa_source=sergiofrancocdpi&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            mainFold: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=24,25,17&dasa_source=sergiofrancocdpi&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            faq: {
                vaccineActive: true,
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=24,25,17&dasa_source=sergiofrancocdpi&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
            about: {
                exams: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=24,25,17&dasa_source=sergiofrancocdpi&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                vaccines: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
            },
        },
        questions: [
            {
                title: 'É permitido levar acompanhantes no atendimento?',
                text: 'Para que possamos respeitar os protocolos de segurança e distanciamento social nas nossas unidades, sugerimos 01 acompanhante apenas para: gestantes, crianças, pessoas com necessidades especiais e pacientes que irão realizar exames onde acompanhantes são indispensáveis (esses casos serão informados no momento do agendamento).',
            },
            {
                title: 'Quais os tipos de Exames realizados?',
                text: 'Realizamos exames de imagem, exames de análises clínicas e vacinas.',
            },
            {
                title: 'Quanto tempo antes devo chegar na unidade?',
                text: 'Chegue com antecedência de 30 minutos do horário marcado em nossas unidades, para realizar os processos de recepção.',
            },
            {
                title: 'Quais são as unidades e horário de funcionamento?',
                text: 'Clique no botão “agendar”, faça seu login, escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!',
            },
        ],
        carousel: [
            {
                title: 'Agendamento de exames',
                button: {
                    text: 'Ver todos os exames',
                    url: `${BASE_URL}entrar?redirectTo=/agd-exames/paciente&brandIds=24,25,17&dasa_source=sergiofrancocdpi&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_exames`,
                },
                image: {
                    src: Images.Becker.src,
                    alt: Images.Becker.alt,
                },
                exams: [
                    { name: 'Hemograma', id: 1307 },
                    { name: 'Glicemia em jejum', id: 548 },
                    { name: 'USG Transvaginal', id: 11513 },
                ],
            },
            {
                title: 'Agendamento de vacinas',
                button: {
                    text: 'Ver todas as vacinas',
                    url: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Syringe.src,
                    alt: Images.Syringe.alt,
                },
                exams: [
                    { name: 'Gripe Quadrivalente', id: 13385 },
                    { name: 'Meningococica B', id: 13395 },
                ],
            },
            {
                title: 'Agendamento de testes',
                button: {
                    text: 'Ver todos os testes',
                    url: `${BASE_URL}entrar?laboratorio=sergiofranco&redirectTo=/vacinas/paciente&brandId=24&dasa_source=sergiofranco&dasa_medium=pagina_deslogada_marca&dasa_campaign=agendamento&dasa_content=agendar_vacinas`,
                },
                image: {
                    src: Images.Glass.src,
                    alt: Images.Glass.alt,
                },
                exams: [
                    { name: 'COVID-19 RT-PCR', id: 14275 },
                    { name: 'Dengue e Anticorpos', id: 1742 },
                    { name: 'Tolerância a Lactose', id: 667 },
                ],
            },
        ],
        renderLPV2: true,
        renderPromoBanner: true,
        lpDesignProps: {
            foldPagePresentationBrand: {
                seo: {
                    title: 'Sérgio Franco e CDPI | Agendamento online de exames e vacinas',
                    metaDescription:
                        'Agende seus exames e vacinas no Nav Dasa, a plataforma digital de saúde dos Laboratórios Sérgio Franco e CDPI.',
                },
                title: 'Agende seus exames e vacinas nos Laboratórios Sérgio Franco e CDPI.',
                subtitle: 'Faça seu agendamento com o Nav Dasa, nossa plataforma de saúde digital.',
                backgroundImage: { src: Images.DefaultBackground.src, alt: Images.DefaultBackground.alt },
                topics: [
                    {
                        icon: 'ClockV2',
                        title: 'Atendimento rápido',
                        text: 'Agendando seus exames e vacinas online, você é atendido mais rapidamente.',
                    },
                    {
                        icon: 'CalendarV2',
                        title: 'Liberdade de agendamento',
                        text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
                    },
                    {
                        icon: 'Magnifier',
                        title: 'Acompanhamento',
                        text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
                    },
                ],
                buttonBackgroundColor: '#2F2A7D',
                buttonTextColor: '#FFFFFF',
            },
            swiper: {
                titleColor: '#FFFFFF',
                title: 'Agende seus exames e vacinas nos Laboratórios Sérgio Franco e CDPI.',
                backgroundColor: '#0095DA',
                buttonBackgroundColor: '#312782',
                buttonTextColor: '#000E40',
                cardColor: '#FEFEFE',
            },
            foldFaq: {
                titleColor: '#000E40',
                buttonBackgroundColor: '#2F2A7D',
                buttonTextColor: '#FFFFFF',
            },
        },
    },
}

export { BrandMapping }
